import { render, staticRenderFns } from "./ManageAllPage.vue?vue&type=template&id=6f60fa1c&scoped=true"
import script from "./ManageAllPage.vue?vue&type=script&lang=ts"
export * from "./ManageAllPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60fa1c",
  null
  
)

export default component.exports